// ============================================================
//  Die Sync-Typen, die die Oberflaeche anbieten darf
//
//  WARUM DAS EINE EIGENE DATEI IST: Die Liste wird an drei Stellen gebraucht
//  (Sammellauf, Profilzeile, Tests). Stuende sie dreimal da, koennte eine
//  Stelle einen Typ bekommen und eine andere nicht — und der Fehler faellt
//  erst auf, wenn jemand genau ueber die vergessene Stelle einen Block
//  aufloesen will.
//
//  WARUM `backfill` FEHLT, obwohl das Backend ihn kennt: Er ist ein
//  Sondertyp fuer ueberwachte Nachladelaeufe, kein Routine-Sync. Ein Knopf
//  dafuer zwischen den taeglichen Typen waere eine Einladung, ihn versehentlich
//  zu treffen. Die Auslassung ist Absicht und wird von einem Test gehalten.
// ============================================================

/** Die Typen, die `POST /sync/start/` annimmt UND die hier waehlbar sind. */
export const SYNC_TYPEN = [
  { wert: 'full', label: 'Full' },
  { wert: 'entities', label: 'Entities' },
  { wert: 'metrics', label: 'Metrics' },
  { wert: 'search_terms', label: 'Search Terms' },
] as const

export type SyncTyp = (typeof SYNC_TYPEN)[number]['wert']

/**
 * Der Vorgabewert. Bewusst `full`: der heutige Klick soll sich nicht aendern,
 * nur zusaetzliche Wahl bekommen.
 */
export const SYNC_TYP_DEFAULT: SyncTyp = 'full'

/**
 * Was die Wahl eines Nicht-Full-Typs bewirkt — der Grund, aus dem es diese
 * Auswahl ueberhaupt gibt.
 *
 * Nach GLB-8 zaehlt ein `full`-Lauf NICHT als Routine-Nachweis fuer einen
 * einzelnen Typ. Ohne Typwahl liesse sich ein offener Sync-Zustands-Block
 * ueber die Oberflaeche also gar nicht aufloesen — man saehe die Sperre und
 * haette kein Mittel dagegen.
 */
export const TYP_HINWEIS =
  'hebt einen offenen Sync-Zustands-Block für diesen Typ auf, sobald der Lauf sauber endet'

/** `full` traegt den Hinweis nicht — er waere dort schlicht falsch. */
export function hinweisFuer(typ: SyncTyp): string | null {
  return typ === 'full' ? null : TYP_HINWEIS
}
